import { createStore, getActionIds } from '../helpers/redux';
import Immutable, { Map } from 'immutable';
// import _ from 'lodash';
import moment from 'moment';
import { ReportActions } from '../actions/report';
import { ProjectActions } from '../actions/project';
import { currentPageIdSelector } from './projectTabs';

const reportActions = getActionIds(ReportActions);
const projectActions = getActionIds(ProjectActions);

const initialState = Immutable.fromJS({
  reports: {},
  meta: {
    sortType: null,
  },
  loading: [],
  loaded: [],
  loadedAll: false,
});

export const reports = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [reportActions.createReport.success]: (state, action) => {
    return state.mergeDeep({
      reports: action.result.entities.report,
    });
  },

  // [reportActions.renameReport.success]: (state, action) => {
  //   return state.mergeDeep({
  //     reports: {
  //       [action.result.result]: {
  //         name: action.result.entities.report[action.result.result].name,
  //       },
  //     },
  //   });
  // },

  [reportActions.getReports.begin]: (state, action) => {
    return state.mergeDeep({
      loadedAll: true,
    });
  },

  [reportActions.getReports.failure]: (state, action) => {
    return state.mergeDeep({
      loadedAll: false,
    });
  },

  [reportActions.getReports.success]: (state, action) => {
    return state.mergeDeep({
      reports: action.result.entities.report,
    });
  },

  [reportActions.deleteReport.success]: (state, action) => {
    return state.deleteIn(['reports', action.result.id]);
  },

  [reportActions.getReport.begin]: (state, action) => {
    return state.mergeDeep({
      loading: state.get('loading').push(action.args[0]),
    });
  },

  [reportActions.getReport.success]: (state, action) => {
    const loadingState = state.get('loading');

    return state
      .mergeDeep({
        reports: action.result.entities.report,
        loaded: loadingState.push(action.args[0]),
      })
      .set(
        'loading',
        loadingState.delete(loadingState.indexOf(action.args[0])),
      );
  },

  [reportActions.getReport.failure]: (state, action) => {
    const loadingState = state.get('loading');

    return state
      .set('loading', loadingState.delete(loadingState.indexOf(action.args[0])))
      .set('loaded', loadingState.delete(loadingState.indexOf(action.args[0])));
  },

  [projectActions.setIcon.success]: (state, action) => {
    const componentType = action.result.result.componentType;

    if (componentType !== 'reports') return state;

    return state.mergeDeep({
      reports: {
        [action.result.result.componentId]: {
          icon_id: action.result.result.iconId,
        },
      },
    });
  },

  [reportActions.runReport.success]: (state, action) => {
    const dataArray = state.getIn(
      ['reports', action.result.reportId, 'data'],
      Immutable.fromJS([]),
    );

    if (dataArray.size === 0) {
      return state.setIn(
        ['reports', action.result.reportId, 'data'],
        Immutable.fromJS(action.result.response),
      );
    }

    return state.setIn(
      ['reports', action.result.reportId, 'data'],
      dataArray.unshift(Immutable.fromJS(action.result.response[0])),
    );
  },
});

export const buildReport = (currentReport, elements, reportHistoryId) => {
  if (!currentReport || elements.size === 0) return null;

  let report = currentReport;
  let orderArray = currentReport.getIn(['data', reportHistoryId, 'data']);

  if (!orderArray) return null;

  orderArray = orderArray.keySeq().toArray();

  orderArray.forEach(data => {
    report = report.setIn(
      ['data', reportHistoryId, 'data', data],
      report.getIn(['data', reportHistoryId, 'data', data]).toFixed(3),
    );
  });

  orderArray.sort((a, b) => {
    const aVal = parseFloat(report.getIn(['data', reportHistoryId, 'data', a]));
    const bVal = parseFloat(report.getIn(['data', reportHistoryId, 'data', b]));

    if (aVal < bVal) return 1;
    if (aVal > bVal) return -1;
    return 0;
  });

  report
    .getIn(['data', reportHistoryId, 'data'])
    .keySeq()
    .toArray()
    .forEach(reportElement => {
      report = report.mergeIn(
        ['reportElements', reportElement],
        elements.get(reportElement),
      );
    });

  report = report.setIn(['data', reportHistoryId, 'orderArray'], orderArray);

  if (report.getIn(['data', reportHistoryId, 'data']).size === 0) {
    report = report.set('loadingReport', false);
  } else if (
    !report.has('reportElements') ||
    !report.hasIn(['data', reportHistoryId, 'data'])
  ) {
    report = report.set('loadingReport', true);
  } else {
    report = report.set(
      'loadingReport',
      report.get('reportElements').size !==
        report.getIn(['data', reportHistoryId, 'data']).size,
    );
  }

  return report;
};

export const shouldLoadReportSelector = state => {
  const currentPageId = currentPageIdSelector(state);

  const loading = state.reports.get('loading').indexOf(currentPageId) === -1;
  const loaded = state.reports.get('loaded').indexOf(currentPageId) === -1;
  const loadedAll = state.reports.get('loadedAll');

  return !loadedAll && (loading && loaded);
};

export const shouldLoadAllReportsSelector = state =>
  !state.reports.get('loadedAll');

export const currentReportSelector = state => {
  const currentPageId = currentPageIdSelector(state);
  const currentReport = state.reports.getIn(['reports', currentPageId], null);

  return currentReport;
};

export const reportsSelector = state => state.reports.get('reports');

const compareDates = (m1, m2) => {
  if (m1 > m2) {
    return 1;
  } else if (m1 < m2) {
    return -1;
  }
  return 0;
};

export const dailyTaskCompleteReportsSelector = state => {
  const reports = state.reports.get('reports');
  if (reports) {
    const taskReports = reports.reduce((map, report) => {
      const id = report.get('id');
      const type = report.get('type');
      if (type === 'Daily Task Complete') {
        return map.set(id, report);
      }
      return map;
    }, Map());

    const sortedReports = taskReports.sort((a, b) =>
      compareDates(moment(a.get('created_at')), moment(b.get('created_at'))),
    );

    return sortedReports;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/reports.js